import React, { useState } from "react";
import { Modal, Typography } from "@mui/material";
import { getModalStyle } from "../CustomHooks/useStyles";

function CustomModal({ modalStatus, modalText, modalTitle }) {
  const [modalStyle] = useState(getModalStyle);

  return (
    <Modal
      aria-labelledby="custom-modal"
      aria-describedby="custom-modal"
      open={modalStatus}
    >
      <div style={modalStyle}>
        <Typography variant="h6" id="modal-update">
          {modalTitle}
        </Typography>
        <Typography variant="body1" id="modal-wait">
          {modalText}
        </Typography>
      </div>
    </Modal>
  );
}

export default CustomModal;
